import { __assign, __awaiter, __extends, __generator } from "tslib";
import { DeviceApiClient } from './device-api';
var DeviceShadowApiClient = /** @class */ (function (_super) {
    __extends(DeviceShadowApiClient, _super);
    /**
     * Custom constructor that supports limit and offset properties.
     * @param {union} baseURL the base URL stack, string or async function that returns string of the desired Stratus stack, which should be obtained from the API discovery service
     * @param {JarvisAuthProvider} authProvider the auth provider for requests this client will make
     * @param {timeout} timeout the request timeout, defaults to 0 (no timeout) if not provided
     * @param {limit} limit the limit of items to fetch, defaults to 10 if not provided
     * @param {offset} offset the offset of items to fetch, defaults to 0 if not provided
     */
    function DeviceShadowApiClient(baseURL, authProvider, timeout, limit, offset) {
        var _this = _super.call(this, baseURL, authProvider, timeout) || this;
        _this.limit = 10;
        _this.offset = 0;
        _this.limit = limit;
        _this.offset = offset;
        return _this;
    }
    DeviceShadowApiClient.prototype.getRtpStatus = function (_a) {
        var cloudId = _a.cloudId, _b = _a.headers, headers = _b === void 0 ? {} : _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getRtpStatusConfigurationSchema(),
                        url: "/".concat(cloudId, "/rtpdevicestatus"),
                        headers: __assign({}, headers),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getRtpConfig = function (_a) {
        var cloudId = _a.cloudId, _b = _a.headers, headers = _b === void 0 ? {} : _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getRtpConfigConfigurationSchema(),
                        url: "/".concat(cloudId, "/rtpconfig"),
                        headers: __assign({}, headers),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getFaxModemConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getFaxModemConfigurationSchema(),
                        url: "/".concat(cloudId, "/faxModem/configuration"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getFaxReceiveConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getFaxReceiveConfigurationSchema(),
                        url: "/".concat(cloudId, "/faxReceive/configuration"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.postFaxModemConfiguration = function (_a) {
        var cloudId = _a.cloudId, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        validationSchema: DeviceShadowApiClient.getFaxModemConfigurationSchema('post'),
                        url: "/".concat(cloudId, "/faxModem/configuration"),
                        data: data,
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.postFaxReceiveConfiguration = function (_a) {
        var cloudId = _a.cloudId, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        validationSchema: DeviceShadowApiClient.getFaxReceiveConfigurationSchema('post'),
                        url: "/".concat(cloudId, "/faxReceive/configuration"),
                        data: data,
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getSystemConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getSystemConfigurationSchema(),
                        url: "/".concat(cloudId, "/system/configuration"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getWifiDirectConfig = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getWifiDirectConfigSchema(),
                        url: "/".concat(cloudId, "/ioConfig/wifiDirectConfig"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getBLEConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getBLEConfigurationSchema(),
                        url: "/".concat(cloudId, "/ble/configuration"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getEth0Configuration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getEth0ConfigurationSchema(),
                        url: "/".concat(cloudId, "/ioConfig/adapterConfigs/eth0"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getWifiConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getWifiConfigurationSchema(),
                        url: "/".concat(cloudId, "/ioConfig/adapterConfigs/wifi0"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getDeviceIdentity = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getDeviceIdentitySchema(),
                        url: "/".concat(cloudId, "/system/identity"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getDeviceSystemStatus = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getDeviceSystemStatusSchema(),
                        url: "/".concat(cloudId, "/system/status"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getLifetimeCounters = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getLifetimeCountersSchema(),
                        url: "/".concat(cloudId, "/deviceUsage/lifetimeCounters/reported"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getSuppliesConfigPrivate = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getSuppliesConfigPrivateSchema(),
                        url: "/".concat(cloudId, "/supply/configPrivate"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getSystemStorage = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getSystemStorageSchema(),
                        url: "/".concat(cloudId, "/storageDevices/systemStorage"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getPowerReboot = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getPowerRebootSchema(),
                        url: "/".concat(cloudId, "/power/reboot"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.postPowerReboot = function (_a) {
        var cloudId = _a.cloudId, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        validationSchema: DeviceShadowApiClient.getPowerRebootSchema(),
                        url: "/".concat(cloudId, "/power/reboot"),
                        data: data,
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getShortcutConfiguration = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceShadowApiClient.getShortcutConfigurationSchema(),
                        url: "/".concat(cloudId, "/shortcut/configuration"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.postShortcutConfiguration = function (_a) {
        var cloudId = _a.cloudId, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        validationSchema: DeviceShadowApiClient.getShortcutConfigurationSchema('post'),
                        url: "/".concat(cloudId, "/shortcut/configuration"),
                        data: data,
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.postSystemConfiguration = function (_a) {
        var cloudId = _a.cloudId, data = _a.data, _b = _a.headers, headers = _b === void 0 ? {} : _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        validationSchema: DeviceShadowApiClient.getSystemConfigurationSchema('post'),
                        url: "/".concat(cloudId, "/system/configuration"),
                        headers: __assign({}, headers),
                        data: data,
                    })];
            });
        });
    };
    // TODO: Add validationSchema
    DeviceShadowApiClient.prototype.getShortcutItemList = function (_a) {
        var cloudId = _a.cloudId, limit = _a.limit, offset = _a.offset;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "/".concat(cloudId, "/shortcut/shortcuts/reported?offset=").concat(offset, "&limit=").concat(limit),
                    })];
            });
        });
    };
    // TODO: Add validationSchema
    DeviceShadowApiClient.prototype.getShortcutCapabilities = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "/".concat(cloudId, "/shortcut/capabilities"),
                    })];
            });
        });
    };
    // TODO: Add validationSchema
    DeviceShadowApiClient.prototype.getShortcutDesiredItem = function (_a) {
        var cloudId = _a.cloudId, itemId = _a.itemId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "/".concat(cloudId, "/shortcut/shortcuts/desired/").concat(itemId),
                    })];
            });
        });
    };
    // TODO: Add validationSchema
    DeviceShadowApiClient.prototype.getShortcutReportedItem = function (_a) {
        var cloudId = _a.cloudId, itemId = _a.itemId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "/".concat(cloudId, "/shortcut/shortcuts/reported/").concat(itemId),
                    })];
            });
        });
    };
    // TODO: Add validationSchema
    DeviceShadowApiClient.prototype.postShortcutDesiredItem = function (_a) {
        var cloudId = _a.cloudId, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: "/".concat(cloudId, "/shortcut/shortcuts/desired"),
                        data: data,
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getDeviceDiscovery = function (_a) {
        var cloudId = _a.cloudId;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(cloudId, "/discovery/apis"),
                    })];
            });
        });
    };
    DeviceShadowApiClient.prototype.getDeviceDiscoveryWithResourceName = function (_a) {
        var cloudId = _a.cloudId, resourceName = _a.resourceName;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(cloudId, "/discovery/apis?resourceName=").concat(resourceName),
                    })];
            });
        });
    };
    DeviceShadowApiClient.getShortcutConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        var required = method === 'post' ? ['desired'] : [];
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                        delta: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['cloudShortcuts'],
                                    properties: {
                                        cloudShortcuts: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                    },
                                },
                            },
                        },
                    },
                    required: required,
                },
            },
        };
    };
    DeviceShadowApiClient.getRtpStatusConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['version', 'supportedPublicKeyId', 'supplyStatus'],
                                    properties: {
                                        version: {
                                            type: 'string',
                                        },
                                        supportedPublicKeyId: {
                                            type: 'string',
                                        },
                                        supplyStatus: {
                                            type: 'object',
                                            additionalProperties: true,
                                        },
                                        lastValidConfigSeqNum: {
                                            type: 'integer',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getRtpConfigConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        var required = method === 'post' ? ['desired'] : [];
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    definitions: {
                        configs: {
                            $id: '#definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['version', 'entityId', 'configSeqNum'],
                                    properties: {
                                        version: {
                                            type: 'string',
                                        },
                                        entityId: {
                                            type: 'string',
                                        },
                                        configSeqNum: {
                                            type: 'integer',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    properties: {
                        reported: { $ref: '#definitions/configs' },
                        desired: { $ref: '#definitions/configs' },
                    },
                    required: required,
                },
            },
        };
    };
    DeviceShadowApiClient.getFaxModemConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        var required = method === 'post' ? ['desired'] : [];
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    definitions: {
                        configs: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: [
                                        'analogFaxReceiveSettings',
                                        'analogFaxOperation',
                                        'analogFaxSetup',
                                    ],
                                    properties: {
                                        analogFaxReceiveSettings: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: ['ringerVolume', 'ringsToAnswer'],
                                            properties: {
                                                ringerVolume: {
                                                    type: 'string',
                                                    enum: ['low', 'medium', 'high', 'off'],
                                                },
                                                ringsToAnswer: {
                                                    type: 'integer',
                                                    minimum: 1,
                                                    maximum: 6,
                                                },
                                            },
                                        },
                                        analogFaxOperation: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: ['dialingMode'],
                                            properties: {
                                                dialingMode: {
                                                    type: 'string',
                                                    enum: ['pulse', 'tone'],
                                                },
                                            },
                                        },
                                        analogFaxSetup: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: [
                                                'faxNumber',
                                                'analogFaxCountry',
                                                'companyName',
                                                'drpdOptions',
                                            ],
                                            properties: {
                                                faxNumber: { type: 'string' },
                                                analogFaxCountry: { type: 'string' },
                                                companyName: { type: 'string' },
                                                drpdOptions: {
                                                    type: 'string',
                                                    enum: [
                                                        'SingleRing',
                                                        'DoubleRing',
                                                        'TripleRing',
                                                        'DoubleAndTripleRing',
                                                        'RecorderRingPattern',
                                                        'AllStandardRings',
                                                        'StartRecord',
                                                        'StopRecord',
                                                    ],
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    properties: {
                        reported: { $ref: '#definitions/configs' },
                        desired: { $ref: '#definitions/configs' },
                    },
                    required: required,
                },
            },
        };
    };
    DeviceShadowApiClient.getFaxReceiveConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        var required = method === 'post' ? ['desired'] : [];
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    definitions: {
                        configs: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['autoAnswerEnabled'],
                                    properties: {
                                        autoAnswerEnabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                    },
                                },
                            },
                        },
                    },
                    properties: {
                        reported: { $ref: '#definitions/configs' },
                        desired: { $ref: '#definitions/configs' },
                    },
                    required: required,
                },
            },
        };
    };
    DeviceShadowApiClient.getSystemConfigurationSchema = function (method) {
        if (method === void 0) { method = 'get'; }
        var required = method === 'post' ? ['desired'] : [];
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: required,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                        delta: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    properties: {
                                        assetNumber: { type: 'string' },
                                        companyContact: { type: 'string' },
                                        companyName: { type: 'string' },
                                        countryRegion: { type: 'string' },
                                        deviceDescription: { type: 'string' },
                                        deviceLanguage: { type: 'string' },
                                        deviceLocation: { type: 'string' },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getWifiDirectConfigSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['enabled', 'ssid', 'currentChannel'],
                                    properties: {
                                        enabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                        ssid: { type: 'string' },
                                        currentChannel: { type: 'integer' },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getBLEConfigurationSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: [
                                        'currentBeaconingEnabled',
                                        'requestedBeaconingEnabled',
                                    ],
                                    properties: {
                                        currentBeaconingEnabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                        requestedBeaconingEnabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getEth0ConfigurationSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['adapterName', 'enabled', 'ipv4', 'macAddress'],
                                    properties: {
                                        adapterName: {
                                            type: 'string',
                                            enum: ['eth0', 'eth1', 'wifi0', 'wifi1'],
                                        },
                                        enabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                        ipv4: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: ['address'],
                                            properties: {
                                                address: {
                                                    type: 'object',
                                                    additionalProperties: true,
                                                    required: ['ip'],
                                                    properties: {
                                                        ip: { type: 'string' },
                                                    },
                                                },
                                            },
                                        },
                                        macAddress: { type: 'string' },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getWifiConfigurationSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: [
                                        'adapterName',
                                        'enabled',
                                        'ipv4',
                                        'macAddress',
                                        'wifiStationConfig',
                                    ],
                                    properties: {
                                        adapterName: {
                                            type: 'string',
                                            enum: ['eth0', 'eth1', 'wifi0', 'wifi1'],
                                        },
                                        enabled: {
                                            type: 'string',
                                            enum: ['true', 'false'],
                                        },
                                        ipv4: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: ['address'],
                                            properties: {
                                                address: {
                                                    type: 'object',
                                                    additionalProperties: true,
                                                    required: ['ip'],
                                                    properties: {
                                                        ip: { type: 'string' },
                                                    },
                                                },
                                            },
                                        },
                                        macAddress: { type: 'string' },
                                        wifiStationConfig: {
                                            type: 'object',
                                            additionalProperties: true,
                                            required: ['wirelessNetwork'],
                                            properties: {
                                                wirelessNetwork: {
                                                    type: 'object',
                                                    additionalProperties: true,
                                                    required: ['ssid'],
                                                    properties: {
                                                        ssid: { type: 'string' },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getDeviceIdentitySchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    properties: {
                                        countryRegion: {
                                            type: 'string',
                                        },
                                        derivativeNumber: {
                                            type: 'string',
                                        },
                                        deviceUuid: {
                                            type: 'string',
                                        },
                                        firmwareCompatibilityId: {
                                            type: 'string',
                                        },
                                        firmwareDateCode: {
                                            type: 'string',
                                        },
                                        firmwareRelease: {
                                            type: 'string',
                                        },
                                        firmwareVersion: {
                                            type: 'string',
                                        },
                                        makeAndModel: {
                                            additionalProperties: true,
                                            properties: {
                                                base: {
                                                    type: 'string',
                                                },
                                                family: {
                                                    type: 'string',
                                                },
                                                name: {
                                                    type: 'string',
                                                },
                                            },
                                            type: 'object',
                                        },
                                        manufacturer: {
                                            type: 'string',
                                        },
                                        productNumber: {
                                            type: 'string',
                                        },
                                        recoveryFirmwareDateCode: {
                                            type: 'string',
                                        },
                                        recoveryFirmwareRelease: {
                                            type: 'string',
                                        },
                                        recoveryFirmwareVersion: {
                                            type: 'string',
                                        },
                                        serialNumber: {
                                            type: 'string',
                                        },
                                        serviceId: {
                                            type: 'string',
                                        },
                                        skuIdentifier: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getDeviceSystemStatusSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['status'],
                                    properties: {
                                        links: {
                                            $ref: '#/definitions/links',
                                        },
                                        status: {
                                            type: 'string',
                                        },
                                        version: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                        links: {
                            $id: '#/definitions/links',
                            type: 'array',
                            maxItems: 32,
                            items: {
                                additionalProperties: true,
                                title: 'link',
                                type: 'object',
                                required: ['rel'],
                                properties: {
                                    enctype: {
                                        type: 'string',
                                    },
                                    hints: {
                                        items: {
                                            additionalProperties: false,
                                            properties: {
                                                method: {
                                                    enum: ['get', 'put', 'patch', 'post', 'delete'],
                                                    type: 'string',
                                                },
                                            },
                                            title: 'hint',
                                            type: 'object',
                                        },
                                        maxItems: 5,
                                        type: 'array',
                                    },
                                    href: {
                                        type: 'string',
                                    },
                                    hrefTemplate: {
                                        type: 'string',
                                    },
                                    rel: {
                                        type: 'string',
                                    },
                                    state: {
                                        default: 'available',
                                        enum: ['available', 'unavailable'],
                                        type: 'string',
                                    },
                                    stateReason: {
                                        enum: ['noHardware', 'unlicensed'],
                                        type: 'string',
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getLifetimeCountersSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['jobUsage'],
                            properties: {
                                jobUsage: {
                                    $ref: '#/definitions/jobUsage',
                                },
                            },
                        },
                        jobUsage: {
                            $id: '#/definitions/jobUsage',
                            type: 'object',
                            additionalProperties: true,
                            properties: {
                                printJobCount: {
                                    type: 'integer',
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getSuppliesConfigPrivateSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: ['antiTheftEnabled', 'supplyPolicy'],
                                    properties: {
                                        antiTheftEnabled: {
                                            enum: ['true', 'false'],
                                            type: 'string',
                                        },
                                        supplyPolicy: {
                                            enum: ['genuineHp', 'any'],
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getSystemStorageSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: false,
                                    required: ['systemDevice1'],
                                    properties: {
                                        systemDevice1: {
                                            $ref: '#/definitions/systemDeviceDetail',
                                        },
                                        systemDevice2: {
                                            $ref: '#/definitions/systemDeviceDetail',
                                        },
                                        systemDevice3: {
                                            $ref: '#/definitions/systemDeviceDetail',
                                        },
                                    },
                                },
                            },
                        },
                        systemDeviceDetail: {
                            $id: '#/definitions/systemDeviceDetail',
                            type: 'object',
                            properties: {
                                name: {
                                    type: 'string',
                                },
                                serialNumber: {
                                    type: 'string',
                                },
                                storageType: {
                                    type: 'string',
                                    enum: ['hdd', 'eMMC', 'ssd', 'nand'],
                                },
                                totalSpace: {
                                    type: 'integer',
                                },
                                usedSpace: {
                                    type: 'integer',
                                },
                                freeSpace: {
                                    type: 'integer',
                                },
                            },
                            additionalProperties: true,
                        },
                    },
                },
            },
        };
    };
    DeviceShadowApiClient.getPowerRebootSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        reported: { $ref: '#/definitions/configs' },
                        desired: { $ref: '#/definitions/configs' },
                    },
                    definitions: {
                        configs: {
                            $id: '#/definitions/configs',
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    properties: {
                                        version: {
                                            type: 'string',
                                        },
                                        state: {
                                            type: 'string',
                                            enum: ['idle', 'pending', 'processing'],
                                        },
                                        lastResult: {
                                            type: 'string',
                                            enum: ['success', 'failed'],
                                        },
                                        failureReason: {
                                            type: 'string',
                                            enum: ['systemBusy', 'unknown'],
                                        },
                                        lastResultTimeStamp: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    return DeviceShadowApiClient;
}(DeviceApiClient));
export { DeviceShadowApiClient };
//# sourceMappingURL=device-shadow-api.js.map